import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as MobileActions from 'actions/index.ts';
import Http from 'services/http2';
import Util from 'lib/util';
import { withStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import AppSelect from './select';
import CompanyService from 'services/company2';
import StoreLocation from 'components/storeLocation';

/**
 * 送货单转收货入库弹窗
 */

const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90%',
  },
});

const btn = {
  primary: {
    color: '#2196f3',
    fontSize: '0.875rem',
    paddingRight: '1rem',
    lineHeight: '2rem',
    height: '2rem',
  },
};

class DeliveryToReceive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: '',
      poLineWarning: '',
      archivesList: null, //单别列表
      storeList: null, //仓库列表
      storeLocalList: null, //库位列表
      formTypeCode: '', //单别编码
      formTypeName: '', //单别名称
      storeCode: '', //仓库编码
      storeName: '', //仓库名称
      locationCode: '', //库位编码
      locationName: '', //库位名称
      showLoading: false,
      showSuccess: false,
      isShowFormType: true, //是否显示单别
      isShowStore: false, //是否展示仓库、库位
      isOpenLocation: false, // 是否显示库位列表弹窗
      addressInitList: [], //收货地址
    };
  }

  //组件加载
  async componentDidMount() {
    await this.getAddressList();
    // this.getArchivesList();
    this.getStoreList();
    // 获取系统参数
    this.getCompanyParams();
  }

  async componentWillReceiveProps() {
    await this.getArchivesList();
    await this.checkInvalidPoLine();
  }

  async getCompanyParams() {
    const { companyCode } = this.props;
    //获取企业参数-是否启用平台收货流程
    let companyParams = {};
    let companyParamsFilter = {};
    CompanyService.getCompanyParamsByCodes(companyCode, [
      'Use_platform_recieve_process',
      'According_To_Purchase_Order_Split_Receipt',
    ]).then(data => {
      data.forEach(item => {
        let paramValue = data.filter(row => row.paramCode === item.paramCode)[0]
          .paramValue;
        let paramFilter = data.filter(
          row => row.paramCode === item.paramCode
        )[0].paramFilter;
        companyParams[item.paramCode] =
          item.paramType === 1 ? paramValue : paramValue === '1';
        companyParamsFilter[item.paramCode] = paramFilter;
      });
      let isShowStore =
        companyParams['Use_platform_recieve_process'] &&
        companyParamsFilter['Use_platform_recieve_process'] === '2';
      let isShowFormType =
        !companyParams['According_To_Purchase_Order_Split_Receipt'];
      this.setState({
        isShowStore: isShowStore,
        isShowFormType: isShowFormType,
      });
    });
  }

  /**
   * 获取ERP单别列表
   * @param companyCode    企业编码
   * @param [billType]     单据类型 1.采购 2.收货 3.入库 4.退货 5.发票 6.销售订单 9.销售退货 12.核价单 22.送货单，51.询价, 52对账单, 16.交料通知
   * @param [purchaseType] 采购类型 1.一般采购 2.委外采购
   */
  async getArchivesList() {
    const { companyCode, billType, detail } = this.props;
    if (Util.isEmpty(detail) || !this.state.isShowFormType) {
      return;
    }
    let postbody = {
      companyCode,
      billType,
      purchaseType: detail.purchaseType ? [detail.purchaseType] : undefined,
      apiPath: '/archives/formType/getList',
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;

        if (Array.isArray(data) && data.length !== 0) {
          let arr = [];
          data.forEach(val => {
            if (val.typeCode) {
              arr.push({
                value: val.typeCode,
                label: val.typeCode + ' - ' + val.typeName,
                name: val.typeName,
                defaultFlag: val.defaultFlag,
                purchaseType: val.purchaseType,
              });
            }
          });
          this.setState({ archivesList: arr });

          //当单别数量为1个时， 自动填充单别
          if (arr.length === 1) {
            this.setState({
              formTypeCode: arr[0].value,
              formTypeName: arr[0].name,
            });
          } else {
            let codes = ['Delivery_Convert_Ro_Def_FormType'];
            if (billType === 3) {
              codes = ['Delivery_Convert_Sto_Def_FormType'];
            }
            CompanyService.getCompanyParamsByCodes(companyCode, codes).then(
              rs => {
                if (!Util.isEmpty(rs)) {
                  let paramValue = rs[0].paramValue;
                  arr.forEach(row => {
                    if (row.value === paramValue) {
                      //根据默认单别赋值
                      this.setState({
                        formTypeCode: paramValue,
                        formTypeName: row.name,
                      });
                    }
                  });
                }
              }
            );

            // 基础资料 - 单别，增加【默认】单别, 取基础资料里面默认单别
            if (detail.purchaseType) {
              arr.forEach(item => {
                if (
                  item.purchaseType &&
                  item.purchaseType.includes(detail.purchaseType.toString()) &&
                  item.defaultFlag === 1
                ) {
                  this.setState({
                    formTypeCode: item.value,
                    formTypeName: item.name,
                  });
                }
              });
            }
          }
        }
      }
    });
  }

  //获取收货地址
  async getAddressList() {
    let postbody = {
      companyCode: this.props.companyCode,
      apiPath: '/archives/inner/delivery/address/getList',
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        this.setState({ addressInitList: response.data });
      }
    });
  }

  //仓库列表
  async getStoreList() {
    const { companyCode, detail } = this.props;

    // 是否开启利润中心
    let isOpenProfit = await CompanyService.checkOpenProfit(companyCode);
    let operateType, profitCenterCode;

    if (isOpenProfit) {
      profitCenterCode = detail.profitCenterCode;
      operateType = 1;
    }

    CompanyService.getStroeList(
      companyCode,
      profitCenterCode,
      '2',
      operateType
    ).then(data => {
      if (Array.isArray(data) && data.length > 0) {
        let arr = [];
        data.forEach(val => {
          if (val.storeCode) {
            arr.push({
              value: val.storeCode,
              label: val.storeCode + ' - ' + val.storeName,
              name: val.storeName,
            });
          }
        });
        this.setState({ storeList: arr });

        let obj =
          this.state.addressInitList?.filter(
            item => item.deliveryPlaceCode === detail.addressCode
          )[0] || {};
        if (!Util.isEmpty(obj)) {
          this.setState({
            storeCode: obj.storeCode,
            storeName: obj.storeName,
          });
        }

        //当仓库地址为1个时， 自动填充仓库地址
        if (arr.length === 1) {
          this.setState({
            storeCode: arr[0].value,
            storeName: arr[0].name,
          });
        }
        this.getStoreLocalList(this.state.storeCode);
      }
    });
  }

  //库位列表
  getStoreLocalList(storeCode) {
    if (Util.isEmpty(storeCode)) {
      return;
    }
    let postbody = {
      companyCode: this.props.companyCode,
      storeCode: storeCode,
      apiPath: '/archives/storeLocation/getList',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        if (Array.isArray(data) && data.length !== 0) {
          let arr = [];
          data.forEach(val => {
            if (val.locationCode) {
              arr.push({
                value: val.locationCode,
                label: val.locationCode
                  ? val.locationCode + ' - ' + val.locationName
                  : val.locationName,
                name: val.locationName,
              });
            }
          });
          this.setState({ storeLocalList: arr });
          //当库位为1个时， 自动填充库位信息
          if (arr.length === 1) {
            this.setState({
              locationCode: arr[0].value,
              locationName: arr[0].name,
            });
          }
        }
      }
    });
  }

  // 检查无效订单项次
  checkInvalidPoLine() {
    const { companyCode, detail } = this.props;
    let postbody = {
      companyCode: companyCode,
      dnXkNo: detail.dnXkNo,
      apiPath: '/vdeliveryNotice/checkNotConvertLine',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      let poLineWarning = '';
      if (response.success && response.data) {
        poLineWarning = response.data;
      } else {
        poLineWarning = null;
      }
      this.setState({ poLineWarning: poLineWarning });
    });
  }

  //单别改变
  handleArchivesChange1 = event => {
    let code = event.value;
    let name;
    this.state.archivesList.forEach(item => {
      if (item.value === code) {
        name = item.name;
      }
    });
    this.setState({
      formTypeCode: code,
      formTypeName: name,
      errorMsg: '',
    });
  };

  //仓库改变
  handleStoreChange1 = event => {
    let code = event.value;
    let name;
    this.state.storeList.forEach(item => {
      if (item.value === code) {
        name = item.name;
      }
    });
    this.setState({
      storeCode: code,
      storeName: name,
      storeLocalList: [],
      locationCode: '',
      locationName: '',
      errorMsg: '',
    });
    this.getStoreLocalList(code);
  };

  //库位改变
  // handleLocationChange1 = event => {
  //   let code = event.value;
  //   let name;
  //   this.state.storeLocalList.forEach(item => {
  //     if (item.value === code) {
  //       name = item.name;
  //     }
  //   });
  //   this.setState({
  //     locationCode: code,
  //     locationName: name,
  //     errorMsg: '',
  //   });
  // };

  handleChange = (event, key) => {
    let val = event.target.value;
    this.setState({ [key]: val });
  };

  handleBlur = (event, key) => {
    let val = event.target.value;
    if (val === '' || val.trim() === '') {
      this.setState({ [key]: val });
    }
  };

  //确定
  handleOk = () => {
    const { companyCode, billType, detail } = this.props;
    let postbody = {
      companyCode,
      dnXkNo: detail.dnXkNo,
      formTypeCode: this.state.formTypeCode,
      formTypeName: this.state.formTypeName,
      storeCode: this.state.storeCode,
      storeName: this.state.storeName,
      locationCode: this.state.locationCode,
      locationName: this.state.locationName,
      apiPath:
        billType === 2
          ? '/vdeliveryNotice/convertReceiveOrder'
          : '/vdeliveryNotice/convertStorageOrder',
    };
    Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        this.setState({
          errorMsg: '',
          archivesList: null, //单别列表
          storeList: null, //仓库列表
          storeLocalList: null, //库位列表
          formTypeCode: '', //单别编码
          formTypeName: '', //单别名称
          storeCode: '', //仓库编码
          storeName: '', //仓库名称
          locationCode: '', //库位编码
          locationName: '', //库位名称
          showLoading: false,
        });
        this.handleClose();
        this.props.onChange(data);
      } else {
        this.setState({ errorMsg: response.errorMsg });
      }
    });
  };

  //关闭
  handleClose = () => {
    const { actions } = this.props;
    actions.closeStockInModal();
  };

  // 显示库位列表弹窗
  showLocation = () => {
    if (Util.isEmpty(this.state.storeCode)) {
      this.setState({ errorMsg: '请先选择仓库' });
      return;
    }
    this.setState({
      isOpenLocation: true,
    });
  };

  // 库位改变
  onLocationClose = locationItem => {
    this.setState({
      isOpenLocation: false,
    });
    if (locationItem) {
      this.setState({
        locationCode: locationItem.locationCode,
        locationName: locationItem.locationName,
        errorMsg: '',
      });
    }
  };

  render() {
    const { classes, data, billType, detail } = this.props;
    return (
      <div>
        <Dialog
          classes={{ paper: classes.paper }}
          open={data.showStockIn}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {billType === 2 ? '转收货单' : '转入库单'}
          </DialogTitle>
          <DialogContent>
            <ul>
              <li className="dialog order-detail-item">
                <div className="line">
                  <span>供应商名称：</span>
                  <div>{detail.innerVendorName}</div>
                </div>
                <div className="line">
                  <span>送货通知单号：</span>
                  <div>{detail.dnXkNo}</div>
                </div>
                {this.state.isShowFormType && (
                  <div className="line">
                    <span>单别：</span>
                    <div>
                      {this.state.archivesList && (
                        <AppSelect
                          value={this.state.formTypeCode}
                          options={this.state.archivesList}
                          change={this.handleArchivesChange1}
                        ></AppSelect>
                      )}
                    </div>
                  </div>
                )}
                {this.state.isShowStore && (
                  <div className="line">
                    <span>仓库：</span>
                    <div>
                      {this.state.storeList && (
                        <AppSelect
                          value={this.state.storeCode}
                          options={this.state.storeList}
                          change={this.handleStoreChange1}
                        ></AppSelect>
                      )}
                    </div>
                  </div>
                )}
                {this.state.isShowStore && (
                  <div className="line">
                    <span>库位：</span>
                    <div>
                      {/* {!Util.isEmpty(this.state.storeLocalList) && (
                        <AppSelect
                          value={this.state.locationCode}
                          options={this.state.storeLocalList}
                          change={this.handleLocationChange1}
                        ></AppSelect>
                      )} */}

                      {/* {Util.isEmpty(this.state.storeLocalList) && (
                        <input
                          type="text"
                          value={this.state.locationName}
                          onChange={e => this.handleChange(e, 'locationName')}
                          onBlur={e => this.handleBlur(e, 'locationName')}
                        />
                      )} */}
                      <p>
                        {this.state.locationCode} - {this.state.locationName}
                      </p>
                      <span style={btn.primary} onClick={this.showLocation}>
                        选择库位
                      </span>
                    </div>
                  </div>
                )}
              </li>
            </ul>
            {this.state.errorMsg && (
              <p className="error-tip">{this.state.errorMsg}</p>
            )}
            {this.state.poLineWarning && (
              <p className="error-tip">{this.state.poLineWarning}</p>
            )}
          </DialogContent>
          <DialogActions>
            <span style={btn.primary} onClick={this.handleClose}>
              取消
            </span>
            <span style={btn.primary} onClick={this.handleOk}>
              确定
            </span>
          </DialogActions>
        </Dialog>
        <StoreLocation
          open={this.state.isOpenLocation}
          onClose={this.onLocationClose}
          companyCode={this.props.companyCode}
          storeCode={this.state.storeCode}
        ></StoreLocation>
      </div>
    );
  }
}

DeliveryToReceive.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.modal,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(DeliveryToReceive)));
